import React from 'react';
import './PageHeader.css';

function PageHeader({ onNavigate }) {
  return (
    <header className="page-header-simple">
      <div className="page-header-simple-content">
        <div className="page-header-side-spacer" aria-hidden="true" />
        <button 
          className="page-header-title-btn page-header-title-btn-centered"
          onClick={() => onNavigate && onNavigate('home')}
        >
          <h1 className="page-header-title">RiskLo</h1>
        </button>
        <div id="risklo-hamburger-slot" className="header-hamburger-slot page-header-hamburger-slot" />
      </div>
    </header>
  );
}

export default PageHeader;

